/**
 * OpenAI extras for the combined eventLogger payload.
 * Event name is the Meta `_eventId` so the backend can map one name to both
 * networks. Does not set `openAIEvent` — the flusher adds that flag only when
 * this mapper actually produced a payload.
 *
 * Does not include CAPI `user` (`emails_sha256`, …). Meta attrs on the same
 * POST already carry `em` / `ph` / `external_id` / geo; the backend formats those.
 */

import type { OpenAiEventDTO } from '../infra/adapters/openai.dto';
import { FACEBOOK_EVENT_MAP } from '@/shared/features/analytics/constants';
import { removeEmptyParams } from '@/shared/features/analytics/utils/adServerEvent';

export function toOpenAiServerEventPayload(
  domainEventName: string,
  dto: OpenAiEventDTO,
): Record<string, unknown> {
  const { contents, type, amount, currency, ...restData } = dto.data;
  const metaEventName = FACEBOOK_EVENT_MAP[domainEventName]?.metaName ?? domainEventName;

  return removeEmptyParams({
    _eventId: metaEventName,
    event_id: dto.options?.event_id,
    oppref: dto.options?.oppref,
    type,
    amount,
    currency,
    contents,
    ...restData,
  });
}
